// Estilo "navy" compartilhado: o mesmo visual do banner do Dashboard e do
// modal de Contato (azul-noite com brilho verde). Só aparência.
// Use dentro do makeStyles de cada página/modal: { hero: heroNavy(theme), ... }

export const VERDE = "#0D9488";
export const VERDE_CLARO = "#2dd4bf";

const escuroDe = (theme) => theme.palette.type === "dark";

// Onda em SVG (periodo de 300px: repete sem emenda a cada 600px).
export const svgOnda = (cor) =>
  `url("data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 600 60' preserveAspectRatio='none'><path d='M0 30 Q75 4 150 30 T300 30 T450 30 T600 30 V60 H0Z' fill='${cor}'/></svg>`
  )}")`;

// Duas camadas de onda no pe de um bloco (usa ::before e ::after).
export const ondasMar = (cor1 = "rgba(255,255,255,0.10)", cor2 = "rgba(255,255,255,0.14)") => ({
  "&::before": {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    height: 54,
    backgroundImage: svgOnda(cor1),
    backgroundSize: "600px 54px",
    backgroundRepeat: "repeat-x",
    animation: "iaMar 22s linear infinite",
    pointerEvents: "none",
    zIndex: 0,
  },
  "&::after": {
    content: '""',
    position: "absolute",
    left: 0,
    right: 0,
    bottom: -4,
    height: 38,
    backgroundImage: svgOnda(cor2),
    backgroundSize: "420px 38px",
    backgroundRepeat: "repeat-x",
    animation: "iaMarVolta 14s linear infinite",
    pointerEvents: "none",
    zIndex: 0,
  },
});

// I.A Recursos Humanos: faixa verde-agua lisa (sem azul-noite, sem estrelas).
export const fundoNavy = "linear-gradient(120deg, #0b5e58 0%, #0d7a72 55%, #0f8f84 100%)";

// Grade sutil + brilho no canto (vai nos ::before/::after do hero/banner).
const decoracao = {
  ...ondasMar(),
  "& > *": { position: "relative", zIndex: 1 },
};

// ───────────────────────── Banner de página ─────────────────────────
export const bannerNavy = (theme) => ({
  position: "relative",
  overflow: "hidden",
  padding: "22px 26px",
  borderRadius: 16,
  color: "#fff",
  background: fundoNavy,
  border: "none",
  boxShadow: escuroDe(theme) ? "0 6px 18px rgba(0,0,0,.35)" : "0 6px 18px rgba(13,94,88,.16)",
  animation: "iaSubir .4s ease backwards",
  ...decoracao,
  "& .MuiSvgIcon-root": { color: "#fff" },
  // Icone dentro de botao segue a cor do texto do botao (botao branco ->
  // icone verde; botao de vidro -> icone branco). Antes sumia no branco.
  "& .MuiButton-root .MuiSvgIcon-root": { color: "inherit" },
  "& .MuiTypography-root, & h1, & h2, & h3, & h4, & h5, & h6": { color: "#fff" },
  "& .MuiTypography-body2, & .MuiTypography-colorTextSecondary, & p": { color: "rgba(255,255,255,.82) !important" },
});

export const bannerTitulo = {
  fontSize: "1.35rem",
  fontWeight: 800,
  color: "#fff",
  display: "flex",
  alignItems: "center",
  gap: 10,
  lineHeight: 1.2,
};

export const bannerSub = { fontSize: "0.86rem", color: "rgba(255,255,255,.82)", marginTop: 4 };

// Botões que ficam sobre o fundo navy.
export const botaoVidro = {
  borderRadius: 12,
  textTransform: "none",
  fontWeight: 700,
  padding: "8px 16px",
  color: "#fff !important",
  backgroundColor: "rgba(255,255,255,0.08)",
  border: "1px solid rgba(255,255,255,0.18)",
  backdropFilter: "blur(6px)",
  "&:hover": { backgroundColor: "rgba(255,255,255,0.16)" },
  "&.Mui-disabled": { opacity: 0.5 },
};

export const botaoVerdeBrilho = {
  borderRadius: 12,
  textTransform: "none",
  fontWeight: 800,
  padding: "8px 18px",
  // botao branco sobre a faixa verde-agua
  color: "#0f766e !important",
  background: "#ffffff",
  "& .MuiSvgIcon-root": { color: "#0f766e !important" },
  boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
  "&:hover": { background: "#f0fdfa" },
};

// Mini-indicadores do banner (ex.: "6 conectadas").
export const bannerStats = {
  display: "flex",
  gap: 10,
  flexWrap: "wrap",
  marginTop: 16,
};
export const bannerStat = {
  minWidth: 120,
  padding: "10px 14px",
  borderRadius: 14,
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(255,255,255,0.12)",
  backdropFilter: "blur(6px)",
  animation: "iaSubir .45s ease backwards",
};
export const bannerStatValor = { fontSize: "1.3rem", fontWeight: 800, color: "#fff", lineHeight: 1.1 };
export const bannerStatRotulo = {
  fontSize: "0.68rem",
  fontWeight: 700,
  letterSpacing: "0.08em",
  textTransform: "uppercase",
  color: "rgba(255,255,255,.75)",
  marginTop: 3,
  display: "flex",
  alignItems: "center",
  gap: 6,
};

// ───────────────────────── Modal ─────────────────────────
export const modalPapel = (theme, largura = 640) => ({
  borderRadius: 24,
  width: "100%",
  maxWidth: largura,
  maxHeight: "90vh",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
  backgroundColor: escuroDe(theme) ? "#0e1716" : "#f4f7fb",
  boxShadow: escuroDe(theme)
    ? "0 30px 80px rgba(0,0,0,0.55), 0 0 0 1px rgba(45,212,191,0.12)"
    : "0 30px 80px rgba(15,23,42,0.22)",
  animation: "iaModalEntrar .22s ease-out",
});

export const modalHero = (theme) => ({
  position: "relative",
  padding: theme.spacing(2.75, 3, 2.25, 3),
  background: fundoNavy,
  color: "#fff",
  flexShrink: 0,
  overflow: "hidden",
  ...decoracao,
});

export const modalHeroLinha = {
  display: "flex",
  alignItems: "center",
  gap: 14,
};

export const modalHeroIcone = {
  width: 48,
  height: 48,
  borderRadius: 14,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  background: "linear-gradient(135deg, #14b8a6, #0f766e)",
  boxShadow: "0 0 0 3px rgba(255,255,255,0.14), 0 8px 22px rgba(0,0,0,0.3)",
  "& svg": { fontSize: 26, color: "#fff" },
};

export const modalHeroEtiqueta = {
  fontSize: "0.66rem",
  fontWeight: 700,
  letterSpacing: "0.14em",
  textTransform: "uppercase",
  color: "#5eead4",
};

export const modalHeroTitulo = {
  fontSize: "1.3rem",
  fontWeight: 800,
  lineHeight: 1.2,
  color: "#fff",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

export const modalHeroSub = { fontSize: "0.82rem", color: "#94a3b8", marginTop: 2 };

export const modalHeroChip = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 10px",
  borderRadius: 999,
  fontSize: "0.76rem",
  fontWeight: 600,
  color: "#fff",
  backgroundColor: "rgba(255,255,255,0.12)",
  border: "1px solid rgba(255,255,255,0.22)",
  backdropFilter: "blur(6px)",
  "& svg": { fontSize: "0.95rem", color: "#fff" },
};

export const modalFechar = {
  color: "#fff !important",
  backgroundColor: "rgba(255,255,255,0.12)",
  "&:hover": { backgroundColor: "rgba(255,255,255,0.24)" },
  "& svg": { color: "#fff" },
};

export const modalCorpo = (theme) => ({
  padding: theme.spacing(2.5, 3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  overflowY: "auto",
  overscrollBehavior: "contain",
  "&::-webkit-scrollbar": { width: 6 },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: escuroDe(theme) ? "rgba(255,255,255,0.18)" : "rgba(13,148,136,0.3)",
    borderRadius: 10,
  },
});

export const modalSecao = (theme) => ({
  borderRadius: 18,
  padding: theme.spacing(2, 2.25),
  backgroundColor: escuroDe(theme) ? "rgba(255,255,255,0.04)" : "rgba(255,255,255,0.9)",
  border: `1px solid ${escuroDe(theme) ? "rgba(255,255,255,0.08)" : "rgba(15,23,42,0.07)"}`,
  boxShadow: escuroDe(theme) ? "none" : "0 6px 20px rgba(15,23,42,0.05)",
  animation: "iaSubir .35s ease backwards",
});

export const modalSecaoTopo = { display: "flex", alignItems: "center", gap: 10, marginBottom: 14 };

export const modalSecaoIcone = {
  width: 30,
  height: 30,
  borderRadius: 10,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
  background: `linear-gradient(135deg, ${VERDE_CLARO}, ${VERDE})`,
  boxShadow: "0 4px 12px rgba(13,148,136,0.35)",
  "& svg": { fontSize: "1.05rem", color: "#fff" },
};

export const modalSecaoTitulo = (theme) => ({
  fontSize: "0.95rem",
  fontWeight: 800,
  color: theme.palette.text.primary,
});

export const modalSecaoSub = (theme) => ({
  fontSize: "0.76rem",
  color: theme.palette.text.secondary,
});

export const modalRodape = (theme) => ({
  padding: theme.spacing(1.75, 3),
  display: "flex",
  alignItems: "center",
  gap: 10,
  flexShrink: 0,
  borderTop: `1px solid ${escuroDe(theme) ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.07)"}`,
  backgroundColor: escuroDe(theme) ? "#0e1716" : "#ffffff",
});

export const campoNavy = (theme) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 12,
    backgroundColor: escuroDe(theme) ? "rgba(255,255,255,0.03)" : "#fff",
    fontSize: "0.9rem",
    transition: "box-shadow .2s ease",
    "& fieldset": { borderColor: escuroDe(theme) ? "rgba(255,255,255,0.12)" : "#e2e8f0" },
    "&:hover fieldset": { borderColor: VERDE },
    "&.Mui-focused": { boxShadow: "0 0 0 4px rgba(13,148,136,0.12)" },
    "&.Mui-focused fieldset": { borderColor: VERDE, borderWidth: "1.5px" },
  },
  "& .MuiInputLabel-outlined.Mui-focused": { color: VERDE },
});

export const botaoPrimario = {
  borderRadius: 12,
  padding: "8px 22px",
  textTransform: "none",
  fontWeight: 800,
  color: "#fff",
  background: `linear-gradient(135deg, #14b8a6, ${VERDE})`,
  boxShadow: "0 6px 16px rgba(13,148,136,0.3)",
  "&:hover": { background: "linear-gradient(135deg, #0d9488, #0f766e)" },
  "&.Mui-disabled": { color: "rgba(255,255,255,0.8)", opacity: 0.55 },
};

export const botaoSecundario = (theme) => ({
  borderRadius: 12,
  padding: "8px 18px",
  textTransform: "none",
  fontWeight: 700,
  color: theme.palette.text.secondary,
  border: `1px solid ${escuroDe(theme) ? "rgba(255,255,255,0.16)" : "#d0d5dd"}`,
  "&:hover": { backgroundColor: escuroDe(theme) ? "rgba(255,255,255,0.06)" : "#f3f4f6" },
});

export const botaoPerigo = {
  borderRadius: 12,
  padding: "8px 14px",
  textTransform: "none",
  fontWeight: 700,
  color: "#e53935",
  "&:hover": { backgroundColor: "rgba(229,57,53,0.08)" },
};

export const botaoPerigoCheio = {
  borderRadius: 12,
  padding: "8px 16px",
  textTransform: "none",
  fontWeight: 800,
  color: "#fff",
  backgroundColor: "#e53935",
  boxShadow: "0 6px 16px rgba(229,57,53,0.3)",
  "&:hover": { backgroundColor: "#c62828" },
};
